/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Field } from '../../models/field';

export interface ApiMasterFieldGetActiveGet$Params {
}

export function apiMasterFieldGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterFieldGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Field>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterFieldGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Field>>;
    })
  );
}

apiMasterFieldGetActiveGet.PATH = '/api/Master/Field/GetActive';
